import React from "react";

const sancoLogo = require('../media/sanco-logo-black.png');

export class SancoHeader extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
render() {
    return (
      <div className="sh-sancoHeader">
        <div id='anglerThm' 
					style={{
						backgroundSize: 'cover',
						backgroundRepeat: 'no-repeat',
						backgroundPosition: '50% 50%',
						width: 60, 
						height: 20,
						marginLeft: 3,
						backgroundImage: 'url(' +  sancoLogo  + ')'
					}} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SancoHeader.js